export const customerName = "customerName";
export const serviceName = "serviceName";
export const orderDate = "orderDate";
export const orderReference = "orderReference";
export const supplierName = "supplierName";
export const category = "category";
export const status = "status";
